import { html, raw } from '../lib/html.js';
import { config } from '../config.js';
import { isValidEmail, passwordProblems } from '../lib/masks.js';
import { autoClearErrors, busy, setFieldError, toastError, valueOf } from '../lib/ui.js';
import { flow } from '../lib/flow.js';
import { auth } from '../services/auth.js';
import { googleButton, wireGoogleButton } from '../services/google.js';
import { Page, brand, go } from './base.js';

class SignupPage extends Page {
  template() {
    return html`
      <ion-header class="ion-no-border">
        <ion-toolbar>
          <ion-buttons slot="start"><ion-back-button default-href="/login" text="Voltar"></ion-back-button></ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding auth">
        <div class="auth-wrap">
          ${raw(brand('Crie sua conta'))}
          ${raw(googleButton('Continuar com Google'))}
          <form novalidate>
            <ion-list lines="none" class="form">
              <ion-input name="email" type="email" label="E-mail" label-placement="floating" fill="outline"
                autocomplete="email" inputmode="email" autocapitalize="off"></ion-input>
              <ion-input name="password" type="password" label="Senha" label-placement="floating" fill="outline"
                autocomplete="new-password" helper-text="Mínimo 8 caracteres, com maiúscula, minúscula e número">
                <ion-input-password-toggle slot="end"></ion-input-password-toggle>
              </ion-input>
              <ion-input name="confirm" type="password" label="Confirme a senha" label-placement="floating" fill="outline"
                autocomplete="new-password">
                <ion-input-password-toggle slot="end"></ion-input-password-toggle>
              </ion-input>
            </ion-list>
            <ion-button type="submit" expand="block" class="submit">Criar conta</ion-button>
          </form>
          <p class="legal">Enviaremos um código para confirmar seu e-mail.</p>
          <p class="legal">
            Ao criar a conta, você concorda com os
            <a href="${config.site.terms}" target="_blank" rel="noopener">Termos de uso</a> e a
            <a href="${config.site.privacy}" target="_blank" rel="noopener">Política de privacidade</a>.
          </p>
        </div>
      </ion-content>`;
  }

  setup() {
    autoClearErrors(this);
    wireGoogleButton(this);
    this.$('form').addEventListener('submit', (e) => {
      e.preventDefault();
      this.submit();
    });
  }

  async submit() {
    const email = valueOf(this, 'email').toLowerCase();
    const password = this.$('ion-input[name="password"]').value ?? '';
    const confirmPwd = this.$('ion-input[name="confirm"]').value ?? '';

    let ok = true;
    if (!isValidEmail(email)) (ok = false), setFieldError(this.$('ion-input[name="email"]'), 'Informe um e-mail válido');
    const problems = passwordProblems(password);
    if (problems.length) (ok = false), setFieldError(this.$('ion-input[name="password"]'), `Falta: ${problems.join(', ')}`);
    else if (password !== confirmPwd) (ok = false), setFieldError(this.$('ion-input[name="confirm"]'), 'As senhas não conferem');
    if (!ok) return;

    await busy(this.$('.submit'), async () => {
      try {
        await auth.signUp(email, password);
        flow.email = email;
        flow.password = password;
        await go('/confirm');
      } catch (err) {
        if (err.code === 'EMAIL_IN_USE') setFieldError(this.$('ion-input[name="email"]'), err.message);
        else if (err.code === 'WEAK_PASSWORD') setFieldError(this.$('ion-input[name="password"]'), err.message);
        else toastError(err.message);
      }
    });
  }
}

customElements.define('page-signup', SignupPage);
